<template>
    <div id="resourceDetail">
        <div class="second-header-wrap">
            <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
            <el-button type="primary"
                       @click="jumpToPage('resourceEdit', {resourceId, courseId, areaCode, courseLevelCode})"
                       v-if="fromType==='manage'" size="medium">编辑
            </el-button>
        </div>

        <div class="main-introdution-wrap custom—scrollbar" :style="{height: mainContainerHeight}">
            <div class="main-container">

                <div class="video-general-container">
                    <video id="video-container" class="video-container"></video>
                    <div class="video-misc-container">
                        <div class="video-misc__name">
                            {{resourseName}}
                        </div>
                        <ul class="video-misc__link-container custom—scrollbar">
                            <li v-for="(videoItem, videoIndex) in videoList"
                                :class="['video-misc__link-item', videoItem.id === id ?'video-misc__link-item--current' : '']">
                                <span v-if="videoItem.id !== id" @click="jumpToOther(videoItem.id)">{{videoItem.resourseName}}</span>
                                <span v-else>{{videoItem.resourseName}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!--<div class="video-general-container&#45;&#45;placeholder"></div>-->

                <div class="resource-info">
                    <div class="resource-info__name">{{resourseName}}</div>
                    <div class="resource-extra-info clearfix">
                        <div class="resource-extra-info__pointer"><i class="fa fa-eye"></i>观看:&nbsp;<span>{{visitorCount}}</span></div><div class="resource-extra-info__pointer resource-extra-info__pointer--praise" @click="praiseHandler">
                        <i :class="['fa', isPraise ? 'fa-thumbs-up' : 'fa-thumbs-o-up']"></i>点赞:&nbsp;<span>{{praiseCount}}</span>
                        </div>
                    </div>
                </div>
                <image-previewer tag="richtext">
                    <div class="introdution-container" v-html="introdution">
                    </div>
                </image-previewer>
                <div class="comment-container">
                    <div class="comment-container__line">
                        <div class="comment-container__line-left"></div>
                        <div class="comment-container__line-right"></div>
                    </div>
                    <div v-if="fromType !== 'manage'" class="add-comment">

                        <img :src="userInfo.avatar" class="comment-avatar"/>
                        <div class="comment-content">
                            <el-input
                                type="textarea"
                                :rows="4"
                                :placeholder="placeholder"
                                v-model.trim="replyContent"
                                maxlength="200"
                            >
                            </el-input>
                            <div class="image-container">
                                <uploader
                                    prefixPath="resourcePlatform"
                                    v-model="files"
                                    :multiple="true"
                                    :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                    showMode="image"
                                    showResult="image"
                                >
                                </uploader>
                            </div>
                        </div>

                        <div class="comment-btn">
                            <el-button type="primary" size="medium" @click="addCommentHandler">发表评论</el-button>
                        </div>
                    </div>

                    <ul class="comment-item-container">
                        <li class="comment-item" @click="showCommentHandler(commentItem.id, commentItem.replyUserId, commentItem.replyUser)" v-for="(commentItem, index) in commentList">
                            <div class="comment-item__avatar">
                                <img :src="commentItem.replyAvatar">
                            </div>
                            <div class="comment-item__main">
                                <div class="comment-item__author">
                                    <template v-if="commentItem.pid === null">
                                        {{commentItem.replyUser}} <span v-if="commentItem.replySchooName" class="schoolName">({{commentItem.replySchooName}})</span>
                                    </template>
                                    <template v-else>
                                        {{commentItem.replyUser}} <span v-if="commentItem.replySchooName" class="schoolName">({{commentItem.replySchooName}})</span> <span style="color:blue">回复</span> {{commentItem.receiverUser}} <span v-if="commentItem.receSchoolName" class="schoolName">({{commentItem.receSchoolName}})</span>
                                    </template>
                                </div>
                                <div class="comment-item__content">{{commentItem.replyContent}}</div>
                                <div @click.stop class="comment-item__photo-container"
                                     v-if="commentItem.replyImageJson && commentItem.replyImageJson !== '[]'">
                                    <image-previewer class="comment-item__photo" :images="commentItem.images" tag="span" > </image-previewer>
                                </div>
                            </div>
                            <div class="comment-item__datetime">
                                {{commentItem.replyTime | timeStampFilter }}
                                <a v-if="commentItem.isTop === 1 && permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1" href="javascript:;" class="setTop" @click.stop="setTop(commentItem.id, 0)">取消置顶</a>
                                <a v-if="commentItem.isTop === 0 && permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1" href="javascript:;" class="setTop" @click.stop="setTop(commentItem.id, 1)">置顶</a>
                            </div>
                        </li>
                    </ul>
                    <div v-if="status !== 1 && commentList.length == 5" class="more-btn" @click="jumpToPage('/main/resourceCommentList', {
                        resourceId,
                        createUserId,
                        fromType
                    })">查看更多评论</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';

    import moment from 'moment';
    import {
        getMoralResourceInfo,
        delResourcePraise,
        addResourcePraise,
        getResourcePraisePageList,
        getIsHavePraiseInfo,
        addResourceRead,
        getSchoolResourceList,
        getCourseMoralEduOLResourceList,
        addMoralEduOLResourceReply,
        findMoralEduOLResourceReplyListByPage,
        commentTop
    } from '@/api/resourceManagement/resourceManagement';
    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import baseMixin from '@/mixins/baseMixin.js';
    import {mapGetters} from 'vuex';

    export default {
        name: "resourceDetail",
        data() {
            return {
                files: [],

                isLoading: false,
                isPraise: false,
                fromType: this.$route.query.fromType,

                status: null,
                areaCode: 0,
                courseLevelCode: this.$route.query.courseLevelCode,
                resourceId: this.$route.query.resourceId,

                placeholder: '请输入评论',

                id: null,
                courseId: 0,
                resourseName: '',
                resourceCover: '',
                createUserName: '',
                createUserId: 0,
                createTime: '',
                introdution: '',
                videoUrl: '',
                resourceLogo: ' ',
                visitorCount: 0,
                praiseCount: 0,
                commentCount: 0,
                mainContainerHeight: 0,
                tcPlayer: null,
                sendSchool: '',
                sendType: 0,

                videoList: [],
                videoId: null,

                currentReplyId: null,
                replyContent: '',
                previewImages: [],

                commentList: []
            }
        },
        filters: {
            sendTypeToStr(value) {
                return ['全部', '学生', '教师'][value];
            },
            timeStampFilter(date) {
                return moment(date).format('YYYY-MM-DD');
            }
        },
        components: {
            ImagePreviewer,
            Uploader
        },
        mixins: [baseMixin],
        computed: {
            ...mapGetters(['userInfo', 'permission'])
        },
        mounted() {
            console.log(this.permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1)
            this.mainContainerHeight = `${window.innerHeight - 162}px`;
            this.getMoralResourceInfoFunc();
            this.findMoralEduOLResourceReplyListByPageFunc();

        },
        beforeDestroy() {
            this.destroyTcPlayer();
        },
        watch: {
            $route: function(newValue, oldValue) {
                this.resourceId  = newValue.query.resourceId;
                this.findMoralEduOLResourceReplyListByPageFunc();
                this.getMoralResourceInfoFunc()
                    .then(() => {
                        this.tcPlayer.loadVideoByID({
                            appID: '1251008840',
                            fileID: this.videoId
                        })
                    })

            }
        },
        methods: {
            setTop(id,num){
                commentTop({
                    isTop:num,
                    replyId:id
                }).then(res=>res.data)
                    .then(data=>{
                        if(data.code===200){
                            this.findMoralEduOLResourceReplyListByPageFunc();
                        }
                    })
            },
            getMoralResourceInfoFunc() {
                return getMoralResourceInfo({
                    resourceId: this.resourceId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.id = data.data.id;
                        this.resourseName = data.data.resourseName;
                        this.createTime = data.data.createTime;
                        this.createUserId = data.data.createUserId;
                        this.createUserName = data.data.createUserName;
                        this.introdution = data.data.introdution;
                        this.videoUrl = data.data.videoUrl;
                        this.videoId = data.data.videoId;
                        this.resourceLogo = data.data.resourceLogo;
                        this.visitorCount = data.data.visitorCount;
                        this.praiseCount = data.data.praiseCount;
                        this.commentCount = data.data.commentCount;
                        this.courseId = data.data.courseId;
                        this.areaCode = data.data.areaCode;
                        this.sendType = data.data.sendType;
                        this.status  = data.data.status;
                        if (data.data.sendSchoolJson) {
                            this.sendSchool = JSON.parse(data.data.sendSchoolJson).map(item => item.name).join('，');
                        }
                        this.getOtherResource();

                        getIsHavePraiseInfo({
                            resourceId: this.resourceId
                        })
                            .then(res => res.data)
                            .then(data => {
                                this.isPraise = data.result;
                            });
                        if (this.fromType === 'user') {
                            if (parseInt(sessionStorage.getItem('addWatch')) === 1) {

                                const isAdmin =
                                    this.permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1
                                    || this.permission.indexOf('/videoResourcePlatform/videoResourcePlatformAccountant') !== -1;
                                if(!isAdmin) {
                                    addResourceRead({
                                        courseId: this.courseId,
                                        resourceId: this.resourceId,
                                        fromType: this.userInfo.type.indexOf('2') !== -1 ? 3 : 2
                                    });
                                }

                                sessionStorage.removeItem('addWatch');
                            }
                        }
                        this.initTcPlayer();
                    });
            },
            jumpToOther(resourceId) {
                sessionStorage.setItem('addWatch', 1);
                this.jumpToPage('resourceDetail', {
                    resourceId,
                    fromType: this.fromType,
                    courseLevelCode: this.courseLevelCode
                }, true);
            },
            showCommentHandler(pid, replyUserId, replyUser) {
                if(this.userInfo.id !== replyUserId && this.fromType !== 'manage') {
                    this.placeholder = `回复${replyUser}`;
                    this.replyContent = '';
                    this.files = [];
                    this.currentReplyId = pid;
                }
            },
            showPreviewer(pics) {
                pics.forEach(item => item.src = item.photoUrl || item.fileUrl);
                if (pics && pics.length !== 0) {
                    this.previewImages = pics;
                    this.$refs.imagePreviewer.showPreviewer();
                }
            },
            findMoralEduOLResourceReplyListByPageFunc() {
                findMoralEduOLResourceReplyListByPage({
                    pageNo: 1,
                    pageSize: 5,
                    resourceId: this.resourceId,
                })
                    .then(res => res.data)
                    .then(data => {
                        data.data.dataList.forEach(item => {
                            const images = JSON.parse(item.replyImageJson);
                            images.forEach(image => image.src = image.photoUrl || image.fileUrl);
                            item.images = images;
                        });
                        this.commentList = data.data.dataList;
                    })
            },
            addCommentHandler() {
                let args = {};

                const replyContent = this.replyContent;
                const replyImageJson = this.files;
                if(replyContent === '') {
                    this.$message({
                        message: '评论不能为空',
                        type: 'error'
                    });
                } else {
                    this.isLoading = true;
                    if(this.currentReplyId) {
                        args = {
                            moralType: 1001,
                            replyContent,
                            replyImageJson,
                            resourceId: this.resourceId,
                            pid: this.currentReplyId
                        }
                    } else {
                        args = {
                            moralType: 1001,
                            replyContent,
                            replyImageJson,
                            resourceId: this.resourceId
                        }
                    }
                    addMoralEduOLResourceReply(args)
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    message: '评论成功',
                                    type: 'success'
                                });
                                setTimeout(() => {
                                    this.replyContent  = '';
                                    this.images = [];
                                    this.files = [];
                                    this.findMoralEduOLResourceReplyListByPageFunc();
                                }, 300);
                            }
                        });
                }

            },
            getOtherResource() {
                const isAdmin = this.permission.indexOf('/videoResourcePlatform/videoResourcePlatformAdmin') !== -1;
                const searchType = this.fromType === 'manage' ? 0 : 2;
                if(isAdmin) {
                    getCourseMoralEduOLResourceList({
                        courseId: this.courseId,
                        status: 2
                    })
                        .then(res => res.data)
                        .then(data => {
                            this.videoList = data.data;
                        })
                } else {
                    getSchoolResourceList({
                        courseId: this.courseId,
                        moralType: 1001,
                        searchTitle: '',
                        searchType: this.userInfo.type.indexOf('1') !== -1 ? 2 : 1
                    })
                        .then(res => res.data)
                        .then(data => {
                            this.videoList = data.data;
                        })
                }

            },
            getResourcePraisePageListFunc() {
                getResourcePraisePageList({
                    pageSize: 5,
                    pageNo: 1,
                    resourceId: this.resourceId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.praiseCount = data.data.pagination.total;
                    })
            },
            praiseHandler() {
                if (this.fromType === 'user') {
                    if (this.isPraise) {
                        delResourcePraise({
                            resourceId: this.resourceId
                        })
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.isPraise = false;
                                    this.getResourcePraisePageListFunc();
                                }
                            })
                    } else {
                        addResourcePraise({
                            resourceId: this.resourceId,
                            fromType: window.location.href.indexOf('stuVideoPlatform') !== -1 ? 1 : 2
                        })
                            .then(res => res.data)
                            .then(data => {
                                if (data.result) {
                                    this.isPraise = true;
                                    this.getResourcePraisePageListFunc();
                                }
                            });
                    }
                }
            },
            initTcPlayer() {
                if(!this.tcPlayer) {
                    setTimeout(() => {
                        if (this.tcPlayer === null) {
                            this.tcPlayer = TCPlayer('video-container', {
                                "autoplay": false,      //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                                "coverpic": {
                                    "style":"stretch", "src":this.resourceLogo
                                },
                                "width": '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                                "height": '100%',//视频的显示高度，请尽量使用视频分辨率高度
                                fileID: this.videoId, // 请传入需要播放的视频filID 必须
                                appID: '1251008840', // 请传入点播账号的 appID 必须
                            });
                        }
                    }, 500);
                }
            },
            destroyTcPlayer() {
                if (this.tcPlayer) {
                    this.tcPlayer.dispose();
                    this.tcPlayer = null;
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin.scss";

    @include reset-global;

    .comment-container {
        margin-top: 50px;
        width: 980px;

        .comment-container__line {
            height: 12px;

            & > * {
                height: 100%;
            }

            .comment-container__line-left {
                float: left;
                width: 80%;
                background-color: #C0F5CB;
            }

            .comment-container__line-right {
                float: right;
                width: 20%;
                background-color: #FFB7B8;
            }
        }

        .add-comment {
            @include clearfix;
            margin-top: 20px;

            .comment-avatar {
                float: left;
                width: 50px;
                height: 50px;
                border-radius: 50%;
            }

            .comment-content {
                float: right;
                width: 900px;
            }
            .comment-btn {
                float:right;
                margin-top: 5px;
            }
        }
        .comment-item-container {
            clear:both;
        }
    }

    .resource-info {
        width: 980px;
        position: relative;
        @include clearfix;

        .resource-info__name {
            line-height: 2.5em;
            font-size: 26px;
            float: left;
            clear: both;
        }

        .resource-extra-info {
            width: auto;
            z-index: 20;
            font-size: 20px;
            color: #333;
            i {
                color: #333;
                margin-right: 10px;
            }
        }

        .resource-info__create-user {
            float: left;
            clear: both;

            span {
                color: #b7bcbf;
            }
        }
    }


    .video-general-container {
        /*position:fixed;*/
        width: 1320px;
        margin: 0 auto;
        padding-top: 10px;
        background-color: #fff;
        @include clearfix;

        .video-container {
            width: 980px;
            height: 500px;
            margin: 0 auto;
            float: left;
        }

        .video-misc-container {
            color: #fff;
            float: right;
            width: 334px;
            height: 500px;
            background-color: #212026;
            box-sizing: border-box;
            padding: 24px 16px;
        }
    }

    .video-general-container--placeholder {
        height: 510px;
    }

    .second-header-wrap {
        position: fixed;
        top: 90px;
        left: 0;
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        z-index: 1000;
    }

    .main-introdution-wrap {
        width: 100%;
        margin-top: 162px;
    }

    .resource-name {
        text-align: center;
        line-height: 60px;
        font-size: 28px;
        margin-bottom: 15px;
    }

    .main-container {
        width: 1320px;
        padding: 0 30px 10px 30px;
        margin: 0 auto;
        min-height: 560px;
    }

    .custom—scrollbar {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .custom—scrollbar::-webkit-scrollbar {
        width: 6px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .custom—scrollbar::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    .custom—scrollbar::-webkit-scrollbar-track {
        background-color: rgba(255, 255, 255, 0.1);
    }


    .resource-extra-info {
        background-color: transparent;
        width: 600px;
        margin: 2px auto;
        text-align: right;
    }

    .resource-extra-info > div {
        display: inline-block;
    }

    .resource-extra-info .fa {
        margin-right: 5px;
    }

    .fa-thumbs-up {
        color: #ff0000 !important;
    }

    .resource-extra-info__pointer {

        margin-left: 30px;
    }
    .resource-extra-info__pointer--praise {
        cursor: pointer;
    }
    .video-misc__name {
        padding-left: 5px;
        box-sizing: border-box;
    }

    .video-misc__link-container {
        margin-top: 30px;
        height: 400px;
        overflow-y: auto;
    }

    .video-misc__link-item {
        box-sizing: border-box;
        padding: 5px;
        margin: 6px 0;
        cursor: pointer;

        &--current {
            background-color: #120D23;
            color: #255EDF;
            cursor: default;
        }
    }
    .comment-item {
        @include clearfix;
        position: relative;
        margin: 20px 0;
        .comment-item__avatar {
            img {
                border-radius: 50%;
                @include wh(50px, 50px);
            }
            float: left;
        }
        .comment-item__main {
            float: right;
            width: 900px;
        }
        .comment-item__author {
            margin-bottom: 10px;
        }
        .comment-item__content {
            width: 89%;
            word-break: break-all;
            font-size: 16px;
        }
        .comment-item__footer {
            color: #999;
            text-align: right;
        }
        .comment-item__datetime {
            position: absolute;
            right: 1px;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    .image-item, .upload-hint {
        @include cover-bg;
        @include middleIB;
        @include wh(70px, 70px);
        margin-right: 5px;
    }
    .image-container {
        margin-top: 6px;
        margin-bottom: 10px;
        .image-item {
            position: relative;
            .delete-file-btn {
                background-size: cover;
                width: 20px;
                height: 20px;
                position: absolute;
                right: 0;
                top: 0;
                background-image: url(https://cdnfile-10043692.file.myqcloud.com/admin/images/upload/close.png);
                display: block;
                float: right;
                cursor: pointer;
            }
        }
        .image-uploader {
            @include middleIB;
        }
    }

    .upload-hint {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 70px;
        &:hover, &:focus {
            border-color: #409EFF;
            color: #409EFF;
        }
        font-size: 28px;
        color: #8c939d;
    }
    .more-btn {
        cursor: pointer;
        text-align: center;
    }
    .schoolName{
        font-size:14px;
    }
</style>
<style lang="scss">
    @import "../../styles/mixin.scss";

    .introdution-container {
        @include richtext;
    }
    .comment-item__photo {
        .images {
            margin-right: 10px;
            width: 60px !important;
            height: 60px !important;
            display: inline-block !important;
            vertical-align: middle !important;
        }
    }

    #resourceDetail {
        .file-name {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/resourceManagement/resourceDetail.vue